module.exports = __webpack_public_path__ + "Tinebase/js/ace-perl6-FAT.js";